export enum GroupType {
    Private = "private",
    Shared = "shared",
}